<template>
  <article :class="{'hidden': !pageStatus.isLoaded}">
    <tab-list
      :status.sync="tabStatus"
      :tab-list="tabList"
      @tab-change="onFirstTab">
    </tab-list>
    <second-sel
      store-name="二手车线索"
      :flag.sync="secondTabStatus"
      :custom-flag="showDate"
      :selList="secondTabList[tabStatus]"
      @select-tab="onSecondTab">
    </second-sel>
    <data-summary
      :title-list="summaryTitle"
      :data-list="summaryData">
    </data-summary>
    <section class="used_car_table">
      <p class="table_title">车辆放行与线索统计</p>
      <group class="diagram_table" gutter="0px">
        <cell class="title">
          <p slot="after-title"><span>&nbsp;</span><em>销售</em><em>售后</em></p>
        </cell>
        <cell :class="item.classNames" v-for="(item, index) in carVisit" :key="index">
          <p slot="after-title"><span>{{item.name}}</span><em class="p-em">{{item.sales}}</em><em>{{item.service}}</em></p>
        </cell>
      </group>
      <div v-if="this.tabStatus === 'monthly'">
        <p class="table_title">各渠道线索到收车漏斗统计</p>
        <ul class="tab-sale-detail">
          <li v-for="v in sourceList" :key="v.key" :class="{on:sourceTab === v.key}" @click.stop="selectSource(v.key)">{{v.name}}</li>
        </ul>
        <group class="diagram_table diagram_table_total" gutter="0px">
          <cell :class="v.classNames" v-for="(v, index) in source" :key="index">
            <p slot="after-title"><span>{{v.name}}</span><em class="p-em">{{v.value}}</em></p>
          </cell>
        </group>
      </div>
      <p class="table_title">各渠道线索占比</p>
      <chart :options="option" theme="pieChart" auto-resize class="mypiechart" v-if="optionEmpty"></chart>
      <p style="color: #ddd;text-align: center; padding: 10px 0 30px 0;" v-else>暂无数据</p>
    </section>
  </article>
</template>
<script>
// echarts 组件是否加载完毕
import theme from './myLineChart.json'
import TabList from '../components/TabList'
import SecondSel from './components/SecondSel'
import DataSummary from './components/DataSummary'
import { Cell, Group } from '@lx-frontend/cvux'
import util from '../../common/util'

let status = {}
status.isLoaded = false
const Chart = () => import(/* webpackChunkName: "ECharts" */ 'vue-echarts').then(ECharts => {
  ECharts.registerTheme('lineChart', theme)
  ECharts.registerTheme('pieChart', theme)
  status.isLoaded = true
  return ECharts
})
let month = util.formatTime(new Date(), 'yyyy-MM')
export default {
  components: {
    TabList,
    SecondSel,
    DataSummary,
    Cell,
    Group,
    Chart
  },
  data() {
    return {
      pageStatus: status, // 状态信息
      tabStatus: 'monthly', // 一级选项状态，默认是月
      tabList: [
        { key: 'daily', name: '日' },
        { key: 'monthly', name: '月' }
      ],
      showDate: month,
      secondTabStatus: 'this_month', // 二级选项状态，默认是本月
      secondTabList: {
        daily: [
          { key: 'today', name: '今日' },
          { key: 'yesterday', name: '昨日' }
        ],
        monthly: [
          { key: 'this_month', name: '本月' },
          { key: 'last_month', name: '上个月' }
        ]
      },
      summaryTitle: [], // 数据概览
      summaryData: {},
      summaryList: [
        { key: 'pending_evaluate', name: '待评估线索(条)' },
        { key: 'pending_appraise', name: '待估价(条)' },
        { key: 'appraised', name: '已估价(台)' },
        { key: 'finished', name: '已完成收车(台)' },
        { key: 'closed', name: '已关闭线索(条)' },
        { key: 'avg_price', name: '收车均价(万)' }
      ],
      carVisit: [
        { key: 'car_release', name: '放行车辆', classNames: 'one' },
        { key: 'satisfy_solicit_rule', name: '符合招揽', classNames: 'two' },
        { key: 'appraised', name: '评估数', classNames: 'three' },
        { key: 'appraised_rate', name: '评估占比' }
      ],
      sourceTab: 'total',
      sourceList: [
        { key: 'total', name: '全部' },
        { key: 'sales', name: '销售' },
        { key: 'service', name: '售后' },
        { key: 'internal', name: '其他' },
        { key: 'mp', name: '公众号' }
      ],
      source: [
        { key: 'used_car', name: '线索', classNames: 'one' },
        { key: 'appraised', name: '到店评估', classNames: 'two' },
        { key: 'finished', name: '完成收车', classNames: 'three' },
        { key: 'finished_rate', name: '收车率' }
      ],
      optionEmpty: false,
      option: {}, // 饼图数据
      tableData: {},
      resDataAll: {}
    }
  },
  mounted() {
    this.getData(this.tabStatus)
  },
  methods: {
    onFirstTab() {
      let queryStatus = this.tabStatus
      this.secondTabStatus = this.secondTabList[queryStatus][0]['key']
      this.getData(queryStatus)
    },
    // 全部统计
    getData(status) {
      this.$rest.dataAnalysis.getUsedcarData(null, `${status}_stat`).then(res => {
        if (res.code === 0) {
          let selStatus = this.secondTabStatus
          this.resDataAll = res.data
          this.selectData(selStatus)
        } else {
          this.showToast(res.message)
        }
      })
    },
    onSecondTab() {
      let selStatus = this.secondTabStatus
      this.sourceTab = 'total'
      this.selectData(selStatus)
    },
    selectData(key) {
      this.tableData = this.resDataAll[key]
      if (!this.tableData) return
      this.showDate = this.tableData.date || this.tableData.month
      // 指标数据展览
      this.summaryData = this.getSummary(this.tableData.summary)
      if (this.secondTabStatus === 'today') {
        this.summaryTitle = this.summaryList
      } else {
        this.summaryTitle = this.summaryList.slice(2)
      }
      // 车辆放行与线索统计
      this.getCarVisit(this.tableData.car_visit)
      // 各渠道线索到收车漏斗统计
      if (this.tabStatus === 'monthly') this.getSource(this.sourceTab)
      // 饼图数据
      let source = this.tableData.source
      if (source.total || source.total.used_car) {
        let list = this.getEchartDataList(source)
        if (list.length) {
          this.option = this.getEchartData(list)
          this.optionEmpty = true
        } else {
          this.optionEmpty = false
        }
      } else {
        this.optionEmpty = false
      }
      // 选项为空时echart不加载,页面直接展示
      if (!this.optionEmpty) {
        this.pageStatus.isLoaded = true
      }
    },
    formatePrice(number) {
      number = number || 0
      return (number / 1000000).toFixed(2)
    },
    formateRate(number) {
      number = number || 0
      return (number * 100).toFixed(2) + '%'
    },
    getSummary(summary) { // 指标数据展览
      // 收车均价可能为null,需要转换单位
      summary.avg_price = this.formatePrice(summary.avg_price)
      return summary
    },
    getCarVisit(carVisitData) { // 车辆放行与线索统计
      let sales = carVisitData.sales
      let service = carVisitData.service
      this.carVisit.forEach((v, i) => {
        let key = v.key
        v.sales = sales[key] || 0
        v.service = service[key] || 0
        if (v.key === 'appraised_rate') {
          v.sales = this.formateRate(sales.appraised_rate)
          v.service = this.formateRate(service.appraised_rate)
        }
      })
    },
    selectSource(key) {
      if (this.sourceTab === key) return false
      this.sourceTab = key
      this.getSource(key)
    },
    getSource(key) { // 各渠道线索到收车漏斗统计
      // fix-sentry https://sentry.lixinio.com/lixin/dos-qiye-frontend/issues/8484/?query=is:unresolved
      let sourceData = Object.assign({}, (this.tableData.source || {})[key])
      this.source.forEach((v, i) => {
        v.value = sourceData[v.key] || 0
        if (v.key === 'finished_rate') {
          v.value = this.formateRate(sourceData.finished_rate)
        }
      })
    },
    getEchartDataList(source) { // 饼图数据日or月
      let echartsData = [
        { value: 'sales', name: '销售' },
        { value: 'service', name: '售后' },
        { value: 'internal', name: '其他' },
        { value: 'mp', name: '公众号' }
      ]
      return echartsData.filter(v => {
        let isValue = typeof source[v.value] === 'number' ? source[v.value] : source[v.value]['used_car']
        v.value = isValue
        return isValue
      })
    },
    getEchartData(list) {
      let chartData = {
        tooltip: { // 点击提示name占比和对应value
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        color: ['#b1e0f8', '#63d29d', '#63c9d2', '#6085ff'],
        series: [{
          type: 'pie',
          radius: '80%',
          center: ['50%', '50%'],
          data: list,
          itemStyle: {
            normal: {
              borderWidth: list.length === 1 ? 0 : 3,
              borderColor: '#fff'
            }
          }
        }]
      }
      return chartData
    }
  }
}
</script>
<style lang="less">
@import "../../stylesheets/modules/data/usedcarData.less";

</style>
